import { EntityType } from '@/plugins/cad/module/CADModule/model/common/constant'
import { getLoggerManager } from '@/shared/logging'
import { AlignDimensionEntity } from './AlignDimensionEntity'
import { AngularDimensionEntity } from './AngularDimensionEntity'
import { ArcEntity } from './ArcEntity'
import type { IEntity } from './BaseEntity'
import { CircleEntity } from './CircleEntity'
import { EllipseEntity } from './EllipseEntity'
import { HatchEntity } from './HatchEntity'
import { MLeaderEntity } from './MLeaderEntity'
import { MTextEntity } from './MTextEntity'
import { PolylineEntity } from './PolylineEntity'
import { RayEntity } from './RayEntity'
import { SplineEntity } from './SplineEntity'

const log = getLoggerManager().getLogger('cad')

/**
 * 实体工厂，根据序列化数据中的 type 字段创建对应实体实例。
 */
export class EntityFactory {
  /**
   * 根据实体数据创建对应子类实例。
   *
   * @param data - 实体序列化数据，依 type 分发到具体实体类
   * @returns 对应实体实例；未知类型时返回 null
   */
  static createEntity(data: IEntity) {
    switch (data.type) {
      case EntityType.Polyline:
        return new PolylineEntity(data)
      case EntityType.Arc:
        return new ArcEntity(data)
      case EntityType.Circle:
        return new CircleEntity(data)
      case EntityType.Spline:
        return new SplineEntity(data)
      case EntityType.MText:
        return new MTextEntity(data)
      case EntityType.MLeader:
        return new MLeaderEntity(data)
      case EntityType.AlignDimension:
        return new AlignDimensionEntity(data)
      case EntityType.Ellipse:
        return new EllipseEntity(data)
      case EntityType.Ray:
        return new RayEntity(data)
      case EntityType.Hatch:
        return new HatchEntity(data)
      case EntityType.AngularDimension:
        return new AngularDimensionEntity(data)
      default:
        log.warn(`Unknown entity type: ${data.type}`)
        return null
    }
  }
}
